import React from "react";
import navOrganization from "@assets/facilityNetwork/nav-organization.svg";
import navIot from "@assets/facilityNetwork/nav-iot.svg";
import navHexagonSparkle from "@assets/facilityNetwork/nav-hexagon-sparkle.svg";
import FacilityNetworkFigmaIcon from "./FacilityNetworkFigmaIcon";

/** Figma Organization glyph — left-rail Network item (#065B70). */
export function NetworkRailIcon() {
  return <FacilityNetworkFigmaIcon src={navOrganization} size={20} />;
}

/** Figma IoT 20px — My Network drawer row (9357:126668 / 9357:126764). */
export function NetworkDrawerIcon() {
  return <FacilityNetworkFigmaIcon src={navIot} size={20} />;
}

/** Figma Hexagon Sparkle 20px — Network Intelligence drawer row (9252:115209). */
export function NetworkIntelligenceDrawerIcon() {
  return <FacilityNetworkFigmaIcon src={navHexagonSparkle} size={20} />;
}
